import { mapKeys } from 'lodash';
import qs from 'qs';

const eloquaPostUri = process.env.REACT_APP_HOMEGEN_ELOQUA_POST_URI;

const DEFAULT_VALUES = {
  first_name: '',
  lastname: '',
  emailaddress: '',
  busphone: '',
  state: '',
  zip: '',
  country: '',
  segment: 'Generators',
  formSubmittingPage1: 'cummins.com/na/generators/residential/generator-size-calculator',
  product_type: 'Residential Property',
  elqFormName: 'cummins-rfq-form',
  elqSiteId: 1480,
  elqDefaultTargetURL: '',
  elqPost: '',
  elqCustomerGUID: '',
  elqCookieWrite: 0,
  form_submission_language: 'English',
};

const FIELD_NAME_MAP = {
  firstName: 'first_name',
  lastName: 'lastname',
  email: 'emailaddress',
  phone: 'busphone',
  state: 'state',
  zipCode: 'zip',
  country: 'country',
};

/**
 * POST user data to Eloqua, check `.env` for post URI
 * @param userData.zipCode
 * @param userData.state
 * @param userData.country
 * @param userData.firstName
 * @param userData.lastName
 * @param userData.phone
 * @param userData.email
 */
export default (userData) => {
  if (!eloquaPostUri) {
    return Promise.reject('No address to submit to.');
  }
  const formData = {
    ...DEFAULT_VALUES,
    ...mapKeys(userData, (_, k) => FIELD_NAME_MAP[k]),
  };
  const params = qs.stringify(formData, { encodeValuesOnly: true });
  const blindFormLink = `${eloquaPostUri}?${params}`;
  // https://s1480.t.eloqua.com/e/f2?submitted[c_first_name]=Test&submitted[c_last_name]=Testman&submitted[c_email_address]=eschoellhorn%2Btest%40352inc.com&submitted[c_phone_number]=123-456-7890&submitted[c_state_province]=FL&submitted[c_zip_postal]=32615&submitted[c_country]=US&elqFormName=SmartForm&elqSiteId=1480&elqDefaultTargetURL=&elqPost=&elqCustomerGUID=&elqCookieWrite=0
  return Promise.resolve(window.open(blindFormLink));
};



// WEBPACK FOOTER //
// ./src/services/eloqua.js